import { useFormContext, type FieldValues } from 'react-hook-form'
import { DatePicker } from '../ui/date-picker'
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../ui/form'

export interface DateFieldProps {
	name:        string
	label?:      string
	placeholder?: string
	disabled?:   boolean
	className?:  string
}

const isoToDate = (iso?: string): Date | undefined => (iso ? new Date(iso) : undefined)
const dateToIso = (d?: Date): string                => (d ? d.toISOString().slice(0, 10) : '')

export function DateField({ name, label, placeholder, disabled, className }: DateFieldProps) {
	const form = useFormContext<FieldValues>()
	return (
		<FormField
			control={form.control}
			name={name}
			render={({ field }) => (
				<FormItem className={className}>
					{label && <FormLabel>{label}</FormLabel>}
					<FormControl>
						<DatePicker
							value={isoToDate(field.value as string | undefined)}
							onChange={(d) => field.onChange(dateToIso(d))}
							placeholder={placeholder}
							disabled={disabled}
							name={name}
						/>
					</FormControl>
					<FormMessage />
				</FormItem>
			)}
		/>
	)
}
